// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Montserrat:400,300,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Montserrat', sans-serif !important;
    text-align: justify;
}

.logoColor {
    color: #ffde59;
}

.quote {
    color: #ffde59;
    font-weight: bold;
    font-size: 1.25rem;
}

.testimonial {
    color: #ffde59;
    font-style: italic;
    font-size: 1.25rem;
    padding: 5px;
    margin: 5px;
}

.banner-bg {
    background-image: url("https://cms.lizakhan.com/assets/6c7225b0-278b-41fa-bf0a-f73542ac2b5f");
}

.banner-space {
    height: 400px;
}

.bg-logoColor {
    background-color: #ffde59;
}

.bg-white-transp {
    background-color: rgba(255, 255, 255, 0.8);
    padding: 15px;
}

.contactInfo {
    text-align: justify;
    line-height: 2.4;
    margin: 0;
}

.contactInfoImg {
    height: 200px;
    width: 70px;
}

.active {
    color: #ffde59;
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: bold;
    text-decoration: none;
    background: 0 0;
    border: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
}

.nonactive {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: bold;
    color: var(--bs-body-color);
    text-decoration: none;
    background: 0 0;
    border: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
}

.articleLink {
    color: var(--bs-body-color);    
}
`, "",{"version":3,"sources":["webpack://./src/lkc.css"],"names":[],"mappings":"AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,oGAAoG;AACxG;;AAEA;IACI,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,oGAAoG;AACxG;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["@import url(\"http://fonts.googleapis.com/css?family=Montserrat:400,300,700\");\n\nbody {\n    font-family: 'Montserrat', sans-serif !important;\n    text-align: justify;\n}\n\n.logoColor {\n    color: #ffde59;\n}\n\n.quote {\n    color: #ffde59;\n    font-weight: bold;\n    font-size: 1.25rem;\n}\n\n.testimonial {\n    color: #ffde59;\n    font-style: italic;\n    font-size: 1.25rem;\n    padding: 5px;\n    margin: 5px;\n}\n\n.banner-bg {\n    background-image: url(\"https://cms.lizakhan.com/assets/6c7225b0-278b-41fa-bf0a-f73542ac2b5f\");\n}\n\n.banner-space {\n    height: 400px;\n}\n\n.bg-logoColor {\n    background-color: #ffde59;\n}\n\n.bg-white-transp {\n    background-color: rgba(255, 255, 255, 0.8);\n    padding: 15px;\n}\n\n.contactInfo {\n    text-align: justify;\n    line-height: 2.4;\n    margin: 0;\n}\n\n.contactInfoImg {\n    height: 200px;\n    width: 70px;\n}\n\n.active {\n    color: #ffde59;\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: bold;\n    text-decoration: none;\n    background: 0 0;\n    border: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n}\n\n.nonactive {\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: bold;\n    color: var(--bs-body-color);\n    text-decoration: none;\n    background: 0 0;\n    border: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n}\n\n.articleLink {\n    color: var(--bs-body-color);    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
